import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText, Loader2 } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { categoriesApi } from '@/lib/api';

const KategorilerPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const data = await categoriesApi.getPublicCategories();
      setCategories(data);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {/* Header */}
      <section className="container-wide py-12 sm:py-16">
        <div className="max-w-2xl">
          <span className="caption text-accent mb-2 block">Keşfet</span>
          <h1 className="heading-article text-foreground mb-4">Kategoriler</h1>
          <p className="body-large text-muted-foreground">
            İlgi alanına göre yazılara ulaş. Her kategori, futbolun farklı bir boyutunu keşfetmeni sağlar.
          </p>
        </div>
      </section>

      {/* Horizontal Rule */}
      <div className="container-wide">
        <div className="h-px bg-border" />
      </div>

      {/* Categories Grid */}
      <section className="container-wide py-12 sm:py-16">
        {categories.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {categories.map((category) => (
              <Link
                key={category._id}
                to={`/kategori/${category.slug}`}
                className="group relative flex flex-col p-8 bg-card border border-border rounded-sm hover:border-accent/30 transition-all card-hover min-h-[200px]"
              >
                {/* Post Count Badge */}
                <div className="absolute top-6 right-6 flex items-center gap-1 text-xs text-muted-foreground">
                  <FileText className="h-3.5 w-3.5" />
                  {category.post_count} yazı
                </div>

                {/* Category Name */}
                <h2 className="font-serif text-2xl font-bold text-foreground mb-3 group-hover:text-accent transition-colors">
                  {category.name}
                </h2>

                {/* Description */}
                <p className="text-muted-foreground text-sm leading-relaxed flex-1">
                  {category.description}
                </p>

                {/* Link Arrow */}
                <div className="flex items-center gap-1 mt-6 text-sm font-medium text-accent">
                  Yazıları Gör
                  <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </div>

                {/* Decorative Element */}
                <div className="absolute bottom-0 right-0 w-24 h-24 opacity-[0.03] pointer-events-none">
                  <svg viewBox="0 0 100 100" className="w-full h-full text-foreground">
                    <rect x="10" y="10" width="80" height="80" fill="none" stroke="currentColor" strokeWidth="2" />
                    <line x1="50" y1="10" x2="50" y2="90" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <p className="text-muted-foreground">Henüz kategori bulunmuyor.</p>
          </div>
        )}
      </section>
    </Layout>
  );
};

export default KategorilerPage;
